import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {FormIngresoService} from "../../../services/forms/form-ingreso.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-dialog-ingreso-aventura',
  templateUrl: './dialog-ingreso-aventura.component.html',
  styleUrls: ['./dialog-ingreso-aventura.component.css']
})
export class DialogIngresoAventuraComponent implements OnInit {

  ingresoForm!:FormGroup;

  constructor(private fb: FormBuilder, private formIngresoService: FormIngresoService , public dialogRef: MatDialogRef<DialogIngresoAventuraComponent>, @Inject(MAT_DIALOG_DATA) public data:any) {

  }

  ngOnInit(): void {
    this.ingresoForm = this.fb.group({
      ingreso: this.formIngresoService.getIngresoEquipoForm()
    });

    console.log(this.ingresoForm);

    this.ingresoForm.get(['ingreso','equipoAlmacen','valoracion'])?.setValue(this.data.valoracion);
    this.ingresoForm.get(['ingreso','equipoAlmacen','observaciones'])?.setValue(this.data.observaciones);
    this.ingresoForm.get(['ingreso','equipoAlmacen','cantidad'])?.setValue(this.data.cantidad);
    this.ingresoForm.get(['ingreso','equipoAlmacen','costo'])?.setValue(this.data.costo);

  }

}
